import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diverse',
  templateUrl: './diverse.component.html',
  styleUrls: ['./diverse.component.scss']
})
export class DiverseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
